module.exports = __webpack_public_path__ + "static/living_room_night-5c0e905a1dc715ed23ccf1273d3f6643.jpg";